const alerts = {
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
}

export default alerts
